// initial state
const state = () => ({

})

// getters
const getters = {

    getStateSidebarActiveMenu(state) {
        return state;
    },

}

// actions
const actions = {}

// mutations
const mutations = {

    setSidebarActiveMenuState(state, payload) {
      for (var [key, value] of Object.entries(payload)) {
          state[key] = value;
      }
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
